import { z } from "zod";

/**
 * Default-free base. `.partial()` in zod v4 still fires `.default()`s, so an
 * update schema derived from a base carrying defaults would inject values the
 * caller never sent — see the note in `role-classifications.ts`.
 *
 * There is no create schema and no `key` field: the four groupings are fixed,
 * each bound to one NOS table its values are read from, and `key` was only ever
 * settable at create time. What an admin owns here is the LABEL — Enable says
 * "Domain" where NOS says "Industry" — plus the description, order and a
 * soft-retire flag.
 */
const constraintTypeFieldsSchema = z.object({
  name: z.string().trim().min(1, "Name is required").max(120, "Name is too long"),
  description: z.string().trim().max(2000).nullable().optional(),
  isActive: z.boolean().optional(),
});

export const constraintTypeUpdateSchema = constraintTypeFieldsSchema.partial();

export const constraintTypeReorderSchema = z.object({
  direction: z.enum(["up", "down"]),
});

export type ConstraintTypeUpdateInput = z.infer<typeof constraintTypeUpdateSchema>;
